module.exports = __webpack_public_path__ + "img/zhaoshang.4a5397e4.png";